import { render, staticRenderFns } from "./PassengerGroupMultiSelect.vue?vue&type=template&id=7b15b772"
import script from "./PassengerGroupMultiSelect.vue?vue&type=script&lang=ts"
export * from "./PassengerGroupMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports